/**
 * Confirm Organization Step
 */

import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

// Pass in initial state
export default function ConfirmOrg({ onNext, onBack, initialConfirmed = false }: { onNext: () => void; onBack: () => void; initialConfirmed?: boolean }) {
    const { accounts } = useMsal();
    const [confirmed, setConfirmed] = useState(initialConfirmed);

    useEffect(() => {
        setConfirmed(initialConfirmed);
    }, [initialConfirmed]);

    const orgName = accounts[0]?.username?.split('@')[1] || 'your organization';
    const userEmail = accounts[0]?.username || '';

    const handleNext = () => {
        if (confirmed) {
            onNext();
        }
    };

    return (
        <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
                <h2 className="text-2xl font-semibold text-gray-900 mb-6">Confirm Your Organization</h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Organization Domain</label>
                        <p className="mt-1 text-lg text-gray-900">{orgName}</p>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Your Email</label>
                        <p className="mt-1 text-gray-900">{userEmail}</p>
                    </div>

                    <div className="pt-4">
                        <div className="flex items-start">
                            <div className="flex h-5 items-center">
                                <input
                                    id="confirm"
                                    type="checkbox"
                                    checked={confirmed}
                                    onChange={(e) => setConfirmed(e.target.checked)}
                                    className="h-4 w-4 rounded border-gray-300 text-[#2ba6bb] focus:ring-[#2ba6bb]"
                                />
                            </div>
                            <div className="ml-3 text-sm">
                                <label htmlFor="confirm" className="font-medium text-gray-700">
                                    I confirm this is my organization
                                </label>
                                <p className="text-gray-500">
                                    You'll be setting up health checks for {orgName}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex items-center justify-between">
                    <button
                        onClick={onBack}
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2ba6bb]"
                    >
                        Back
                    </button>
                    <button
                        onClick={handleNext}
                        disabled={!confirmed}
                        type="button"
                        className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${confirmed
                            ? 'bg-[#2ba6bb] hover:bg-[#228a9d] focus:ring-[#2ba6bb]'
                            : 'bg-gray-300 cursor-not-allowed'
                            } focus:outline-none focus:ring-2 focus:ring-offset-2`}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}
